import { create } from "zustand";
export const useInvoicesStore = create((set) => ({
  invoices: null,
  invoicesCompanyDetail: null,
  setInvoices: (invoices) => {
    set({ invoices });
  },
  setInvoicesCompanyDetail: (invoicesCompanyDetail) => {
    set({ invoicesCompanyDetail });
    console.log("invoices", invoicesCompanyDetail);
  },
}));
